import { PropsWithChildren, useEffect, useState } from 'react'

import { XyoWorldMapStyle } from '../../lib'
import { AppSettingsContext, PlayMapSettings } from './Context'
import useAppSettings from './useAppSettings'

interface Props {
  enabled?: boolean
}

export const AppSettingsLoader: React.FC<PropsWithChildren<Props>> = (props) => {
  const { children } = props

  const settings = useAppSettings()

  const [infuraAsDefaultProvider, setInfuraAsDefaultProvider] = useState(settings.infuraAsDefault)
  const [developerMode, setDeveloperMode] = useState(settings.developerMode)
  const [darkMode, setDarkMode] = useState(settings.darkMode)
  const [requestLocation, setRequestLocation] = useState(settings.requestLocation)
  const [mapStyle, setMapStyle] = useState(settings.mapStyle)
  const [playMapSettings, setPlayMapSettings] = useState(settings.playMapSettings)

  const enableInfuraAsDefaultProvider = (value: boolean) => {
    settings.infuraAsDefault = value
    setInfuraAsDefaultProvider(settings.infuraAsDefault)
  }

  const updatePlayMapSettings = (value: PlayMapSettings) => {
    settings.playMapSettings = value
    setPlayMapSettings(settings.playMapSettings)
  }

  const enableDeveloperMode = (value: boolean) => {
    settings.developerMode = value
    setDeveloperMode(settings.developerMode)
  }

  const enableDarkMode = (value: boolean) => {
    settings.darkMode = value
    setDarkMode(settings.darkMode)
  }

  const enableRequestLocation = (value: boolean) => {
    settings.requestLocation = value
    setRequestLocation(settings.darkMode)
  }

  const updateMapStyle = (value: XyoWorldMapStyle) => {
    settings.mapStyle = value
    setMapStyle(settings.mapStyle)
  }

  useEffect(() => {
    if (requestLocation) {
      const watchId = navigator.geolocation.watchPosition((position) => {
        console.log(`Location: ${position.coords.latitude}, ${position.coords.longitude}`)
      })
      return () => navigator.geolocation.clearWatch(watchId)
    }
  }, [requestLocation])

  return (
    <AppSettingsContext.Provider
      value={{
        darkMode,
        developerMode,
        enableDarkMode,
        enableDeveloperMode,
        enableInfuraAsDefaultProvider,
        enableRequestLocation,
        infuraAsDefaultProvider,
        mapStyle,
        playMapSettings,
        requestLocation,
        updateMapStyle,
        updatePlayMapSettings,
      }}
    >
      {children}
    </AppSettingsContext.Provider>
  )
}
